import { ViewModel } from '../view-model';
import { FailureRateUom } from '../../viewmodels/equipment/equipment-failure-mode';

export class OptimizationFailureRateOption implements ViewModel {
  friendlyTypeNameSingular = 'Failure Rate Option';
  apiRoute: string = '';

  functionName: string;
  functionalFailureName: string;
  failureModeId: string;
  failureModeName: string;
  failureRate: number;
  failureRateUom: FailureRateUom;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.functionName = data.functionName;
    this.functionalFailureName = data.functionalFailureName;
    this.failureModeId = data.failureModeId;
    this.failureModeName = data.failureModeName;
    this.failureRate = data.failureRate;
    this.failureRateUom = data.failureRateUom;
  }
}
